import React from "react";
import { CheckIcon, GlobeIcon, LockIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
import { bonuses, images, offerChecklist } from "../data/landing";
export function Offer() {
  return <section id="offer" className="scroll-mt-4 bg-navy-900 px-4 py-16 sm:py-20" data-id="element-205" data-mp="1hnw8ej178wvm">
      <div className="mx-auto max-w-2xl" data-id="element-206" data-mp="tyv1j080ltsg">
        <h2 className="text-center font-display text-3xl font-black leading-tight text-white sm:text-4xl" data-id="element-207" data-mp="tzmoxnrgkl7n">
          Here's Everything You'll Receive <span className="text-gold-400" data-id="element-208" data-mp="p24ratiw5sey">Today</span>
        </h2>
        <p className="mt-2 text-center text-sm font-semibold text-gold-300" data-id="element-209" data-mp="13ym1hhfch0zx">Your special launch offer</p>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white text-navy-900 ring-4 ring-gold-400" data-id="element-210" data-mp="ywd7qiunduwr">
          <img src={images.product} alt="Denture Blueprint complete collection" className="w-full bg-cream" data-id="element-211" data-mp="2fad2zgijswdo" />
          <div className="p-5 sm:p-8" data-id="element-212" data-mp="2af7gafhbndoj">
            <div className="flex items-start justify-between gap-4 border-b border-navy-900/10 pb-4" data-id="element-213" data-mp="pkqnc8hm1r98">
              <div data-id="element-214" data-mp="uiiprwfvsvro">
                <h3 className="text-lg font-extrabold" data-id="element-215" data-mp="ui0js83f336k">Denture Blueprint™ — The Six-Volume Collection</h3>
                <p className="mt-1 text-sm text-navy-700" data-id="element-216" data-mp="zjpufmmq9eu4">Assessment, anatomy, impressions, stability & retention, occlusal concepts, and clinical documentation.</p>
              </div>
              <s className="shrink-0 text-base font-bold text-navy-600" data-id="element-217" data-mp="6use3p22ts40">$97</s>
            </div>
            <div className="border-b border-navy-900/10 py-4" data-id="element-218" data-mp="btvlvh9fycfo">
              <div className="flex items-start justify-between gap-4" data-id="element-219" data-mp="fufjelxxfi2c">
                <h3 className="text-lg font-extrabold" data-id="element-220" data-mp="ft4bqb1d1q5y">The Five Exclusive Bonuses</h3>
                <s className="shrink-0 text-base font-bold text-navy-600" data-id="element-221" data-mp="kmp3hlcd1nwp">$83</s>
              </div>
              <ul className="mt-2 space-y-1" data-id="element-222" data-mp="3k846a21t7wwr">
                {bonuses.map(b => <li key={b.number} className="text-sm text-navy-700" data-id="element-223" data-mp="3o8wh2zqby9v5">#{b.number} {b.title}</li>)}
              </ul>
            </div>

            <div className="py-6 text-center" data-id="element-224" data-mp="qgnq2c3h6whl">
              <p className="text-sm font-bold text-navy-700" data-id="element-225" data-mp="qfut22ubjlcn">
                Total suggested reference value: <s className="text-red-600" data-id="element-226" data-mp="1548tk749ixq1">$180</s>
              </p>
              <p className="mt-2 text-base font-extrabold" data-id="element-227" data-mp="105xjpwdywn7t">Today, get the complete collection for just</p>
              <p className="font-display text-7xl font-black leading-none text-navy-950 sm:text-8xl" data-id="element-228" data-mp="cg36vetneynk">$27</p>
              <p className="mt-1 text-sm font-semibold text-emerald-700" data-id="element-229" data-mp="7il466685fo0">One-time payment · You save $153</p>
            </div>

            <ul className="grid gap-2 sm:grid-cols-2" data-id="element-230" data-mp="lj4c7daowlq6">
              {offerChecklist.map(item => <li key={item} className="flex items-center gap-2 text-[15px] font-semibold" data-id="element-231" data-mp="heo7hfctbkcj">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-500 text-white" data-id="element-232" data-mp="1wv58redspegh">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-233" data-mp="1sxh59my1edcz" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7" data-id="element-234" data-mp="25f1t647s9aql">
              <CTAButton label="Yes! Get My Denture Blueprint for $27" data-id="element-235" data-mp="1qgptdop45lv7" />
            </div>

            <div className="mt-5" data-id="element-236" data-mp="1vfkonq49p2w7">
              <Countdown data-id="element-237" data-mp="1vglyjr9jrjcc" />
            </div>
            <div className="mt-5" data-id="element-238" data-mp="1vhnd45prunyt">
              <ScarcityBar data-id="element-239" data-mp="2j4lpar6uz9qx" />
            </div>

            <div className="mt-5 flex gap-3 rounded-2xl bg-sand p-4" data-id="element-240" data-mp="2j5x3lkxxjzwa">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-800" aria-hidden="true" data-id="element-241" data-mp="2o36ocnadjnds" />
              <p className="text-sm leading-snug text-navy-800" data-id="element-242" data-mp="29eak71bfuuig">
                <strong data-id="element-243" data-mp="2eef1gtk67t9q">Automatic currency conversion:</strong> checkout converts the price to your local currency automatically and shows applicable taxes, if any.
              </p>
            </div>

            <p className="mt-5 flex items-center justify-center gap-1.5 text-center text-sm font-semibold text-navy-700" data-id="element-244" data-mp="36uprqv8b93gc">
              <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-245" data-mp="1j6o8ilnm5o99" /> Instant Digital Access · One-Time Payment · 7-Day Guarantee
            </p>
            <p className="mt-4 text-center text-sm leading-relaxed text-navy-700" data-id="element-246" data-mp="1e605t2q0viz7">
              You're not purchasing a lengthy video course. You're getting a structured collection of practical reference materials designed for everyday professional use.
            </p>
            <p className="mt-3 text-center text-xs text-navy-600" data-id="element-247" data-mp="21vujtnm2vdl1">The reference values above are illustrative estimates, not independently established market prices.</p>
          </div>
        </div>
      </div>
    </section>;
}